import React from 'react';
import withSizes from 'react-sizes';
import { OuterWrapper, PageContentWrapper, BannerWrapper, SiteContentWrapper, Container, Row, MainWrapper, AsideWrapper, Main, Aside, isSizes } from '~layout';
import { useHasMounted } from '~helpers';

var LeftAsideTemplate = function LeftAsideTemplate(_ref) {
  var main = _ref.main,
      bgStart = _ref.bgStart,
      bgEnd = _ref.bgEnd,
      banner = _ref.banner,
      aside = _ref.aside,
      footer = _ref.footer,
      isMobile = _ref.isMobile,
      isFullWidth = _ref.isFullWidth;
  var hasMounted = useHasMounted();

  if (!hasMounted) {
    return null;
  }

  return /*#__PURE__*/React.createElement(OuterWrapper, null, /*#__PURE__*/React.createElement(PageContentWrapper, {
    bgStart: bgStart,
    bgEnd: bgEnd
  }, /*#__PURE__*/React.createElement(BannerWrapper, null, banner), /*#__PURE__*/React.createElement(SiteContentWrapper, {
    isFullWidth: isFullWidth
  }, /*#__PURE__*/React.createElement(Container, null, /*#__PURE__*/React.createElement(Row, {
    flexWrap: isMobile ? 'wrap' : 'nowrap'
  }, /*#__PURE__*/React.createElement(AsideWrapper, {
    order: isMobile ? 1 : 0
  }, /*#__PURE__*/React.createElement(Aside, null, aside)), /*#__PURE__*/React.createElement(MainWrapper, null, /*#__PURE__*/React.createElement(Main, null, main)))))), footer);
};

LeftAsideTemplate.defaultProps = {
  bgEnd: null,
  main: null,
  aside: null,
  banner: null,
  footer: null,
  isMobile: false,
  isFullWidth: false
};

var mapSizesToProps = function mapSizesToProps(_ref2, _ref3) {
  var width = _ref2.width;
  var theme = _ref3.theme;
  return {
    isMobile: isSizes.mdView({
      width: width
    }, {
      theme: theme
    })
  };
};

export default withSizes(mapSizesToProps)(LeftAsideTemplate);